import { Button, Card } from 'react-bootstrap';
import { format, addMonths, subMonths, addWeeks, subWeeks, addDays, subDays } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar, faCalendarDays, faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
//import { ViewMode } from '@/types/appointment';


export const CalendarHeader =({ currentDate, viewMode, onDateChange }) =>{
  const handlePrevious = () => {
    switch (viewMode) {
      case 'month':
        onDateChange(subMonths(currentDate, 1));
        break;
      case 'week':
        onDateChange(subWeeks(currentDate, 1));
        break;
      case 'day':
      case 'list':
        onDateChange(subDays(currentDate, 1));
        break;
    }
  };

  const handleNext = () => {
    switch (viewMode) {
      case 'month':
        onDateChange(addMonths(currentDate, 1));
        break;
      case 'week':
        onDateChange(addWeeks(currentDate, 1));
        break;
      case 'day':
      case 'list':
        onDateChange(addDays(currentDate, 1));
        break;
    }
  };

  const handleToday = () => {
    onDateChange(new Date());
  };

  const getDateDisplay = () => {
    switch (viewMode) {
      case 'month':
        return format(currentDate, "MMMM 'de' yyyy", { locale: ptBR });
      case 'week':
        return format(currentDate, "'Semana de' dd 'de' MMMM", { locale: ptBR });
      case 'day':
      case 'list':
        return format(currentDate, "dd 'de' MMMM 'de' yyyy", { locale: ptBR });
    }
  };

  return (
    <Card className="shadow-sm animate-fade-in">
      <Card.Body className="d-flex justify-content-between align-items-center py-3">
        <div className="d-flex align-items-center gap-2">
         <FontAwesomeIcon icon={faCalendar}/>
          <h5 className="mb-0 fw-bold text-capitalize"> {getDateDisplay()}</h5>
        </div>

        <div className="d-flex align-items-center gap-2">
          <Button variant="outline-secondary" size="sm" onClick={handleToday}>
            Hoje
          </Button>
          <div className="btn-group">
            <Button variant="outline-secondary" size="sm" onClick={handlePrevious}>
              <FontAwesomeIcon icon={faChevronLeft} />
              
            </Button>
            <Button variant="outline-secondary" size="sm" onClick={handleNext}>
            <FontAwesomeIcon icon={faChevronRight}/>
            </Button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
}
